<template>
  <address v-if="list == true" class="mb-0">
    <template v-if="address.supplier && address.supplier.name">
      <b>{{ address.supplier.name }}</b>
      <br />
    </template>
    <div>
      <span v-if="address.contactName">{{ address.contactName }}</span>
      <span v-if="address.companyName"> | {{ address.companyName }}</span>
    </div>

    <template v-if="address.street1 || address.Street1" class="mr-1">
      {{ address.street1 || address.Street1 }}
    </template>
    <template v-if="address.street2 || address.Street2" class="mr-1">
      {{ address.street2 || address.Street2 }}
    </template>
    {{ address.city || address.City }}, {{ address.state || address.State }} {{ address.zip || address.Zip }}
    {{ address.country || address.Country }}

    <!-- <template v-if="address.supplier && address.supplier.name">
      ( {{ address.supplier.name }})
      <br />
    </template> -->
  </address>

  <address v-else>
    <template v-if="address.supplier && address.supplier.name">
      <b>{{ address.supplier.name }}</b>
      <br />
    </template>
    <div class="small mr-2" v-if="address.contactName">{{ address.contactName }}</div>
    <div class="small mr-2" v-if="address.companyName">{{ address.companyName }}</div>

    <template v-if="address.street1 || address.Street1">
      {{ address.street1 || address.Street1 }}
      <br />
    </template>
    <template v-if="address.street2 || address.Street2">
      {{ address.street2 || address.Street2 }}
      <br />
    </template>
    {{ address.city || address.City }}, {{ address.state || address.State }} {{ address.zip || address.Zip }}
    <br />
    {{ address.country || address.Country }}
    <br />
  </address>
</template>
<script>
export default {
  name: 'AddressFormat',
  props: {
    address: {
      type: Object,
      required: true
    },
    list: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {};
  }
};
</script>
